import React, { useEffect, useRef, useState } from "react";
import { MainMenuStyle, MainMenuContainerStyle, MainMenuWrapper } from "./MainMenu.style";
import { Media, MediaImage, Box } from "../../types";
import BoxList from "../BoxList/BoxList.component";

interface Props {
  boxList: Box[];
  onChangeBoxListContainerWidth?: (boxWith: number) => void;
}

const MainMenu: React.FC<Props> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [boxWidth, setBoxWidth] = useState(0);

  useEffect(() => {
    if (boxWidth === 0) {
      setBoxWidth(ref.current ? ref.current.offsetHeight : 0);
    }
  }, [ref]);

  useEffect(() => {
    if (boxWidth !== 0 && props.onChangeBoxListContainerWidth) {
      props.onChangeBoxListContainerWidth(boxWidth);
    }
  }, [boxWidth]);
  return (
    <MainMenuStyle className={"main-menu"}>
      <MainMenuWrapper className={"main-menu-wrapper"}>
        <MainMenuContainerStyle autoWidth={boxWidth} ref={ref} className={"main-menu-boxlist-container"}>
          <BoxList boxList={props.boxList} />
        </MainMenuContainerStyle>
      </MainMenuWrapper>
    </MainMenuStyle>
  );
};

export default MainMenu;
